/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo } from "react";
import axios, { acceptDownloadResponse } from "utils/httpClient";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Popup from "reactjs-popup";
import SignaturePad from "react-signature-canvas";

// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import { Collapse, Modal, ModalBody } from "reactstrap";
// import avatar from "assets/img/faces/marc.jpg";
import garuda from "assets/img/garuda2.jpg";
import "./custom-style.css";
import logoDMS from "assets/img/1_logoDMS.jpg";
import logo from "assets/img/skin.png"; 
import ReactFullScreenElement from "react-fullscreen-element";
import KeyboardEventHandler from "react-keyboard-event-handler";
var currentUser = "";
if(JSON.parse(localStorage.getItem('currentUser')) !== null){
  currentUser = JSON.parse(localStorage.getItem('currentUser'))
} 

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const styles2 = {
  signatureCanvas: {
    border: "1px solid black",
    width: "100%",
    minHeight: "350px"
  }
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

const Digital2568 = props => {
  const [imageURL, setImageURL] = useState(null);
  const [imageURL2, setImageURL2] = useState(null);
  const [modal, setModal] = useState(false);
  const [modalSig, setModalSig] = useState(false);
  const [modalSig2, setModalSig2] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [isOpen, setIsOpen] = useState(false);
  const sigCanvas = useRef({});
  const [isMobile, setIsMobile] = useState(false);
  const [configPolicy, setConfigPolicy] = useState(false);
  const [modalPolicy, setModalPolicy] = useState(false);
  const [modalPolicy2, setModalPolicy2] = useState(true);
  const [PDF, setPDF] = useState(null);
  const [fullScreen, setFullScreen] = useState(false);

  const customData = 2568;

  function setFullScreenKey(e) {
    if (
      e === "esc"
    )
    {
      setFullScreen(false);
    }
  }

  const handleResize = () => {
    if (window.innerWidth < 720) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  // create an event listener
  useEffect(() => {
    window.addEventListener("resize", handleResize);
  });

  const clear = () => sigCanvas.current.clear();

  const save = () =>
    setImageURL(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));

  const save2 = () =>
    setImageURL2(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));

  const classes = useStyles();
  const classes2 = useStyles2();

  const handleSubmit = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];

    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModalSig(true);
    }
  };

  function DataURIToBlob(dataURI) {
    const splitDataURI = dataURI.split(",");
    const byteString =
      splitDataURI[0].indexOf("base64") >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(":")[1].split(";")[0];

    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i);

    return new Blob([ia], { type: mimeString });
  }

  function handleConfirm() {
    setImageURL(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");
    const fileField = DataURIToBlob(
      sigCanvas.current.getTrimmedCanvas().toDataURL("image/png")
    );
    const file = new File([fileField], "File name", { type: "image/png" });
    const formData = new FormData();
    formData.append("files", file);
    axios.post("/api/v1/data/signature/" + 28,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    .then(
      result => {
        if(result.data.result == 200)
        {
          setModalSig(false);
          setIcon("far fa-question-circle");
        }
      }, error => { console.log(error); }
    ); 
  }

  function handleConfirm2() {
    setImageURL2(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");
    const fileField = DataURIToBlob(
      sigCanvas.current.getTrimmedCanvas().toDataURL("image/png")
    );
    const file = new File([fileField], "File name", { type: "image/png" });
    const formData = new FormData();
    formData.append("files", file);
    axios.post("/api/v1/data/signature/" + 30,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    .then(
      result => {
        if(result.data.result == 200)
        {
          setModalSig2(false);
          setIcon("far fa-question-circle");
        }
      }, error => { console.log(error); }
    ); 
  }

  const handleSubmit2 = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];

    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModalSig2(true);
    }
  };

  useEffect(() => {
    axios.get("/api/v1/configSignature/" + 1)
    .then(
      result => {
          if(result.status == 200)
          {
            if(result.data.data.value === "1") {
              setConfigPolicy(true)
            }
          }
        },
        error => {console.log(error); }
    );  
  }, []);

  const handleSubmitPolicy = evt => {
    setConfigPolicy(false);
    //setModalPolicy(true);
    handleSubmitPDF2();
  }

  const handleSubmitPDF2 = evt => {

    var cntErr = 0;
    var errMsg = [];

    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      axios("/api/v1/download/pdf/" + 5 + "/" + customData, {
        method: "POST",
        responseType: "blob",
        validateStatus: acceptDownloadResponse
      })
        .then(response => ((response.status >= 200 && response.status < 300) ? response.data : false))
        .then(
          blob => {
            if (!blob) {
              console.log("ไม่พบไฟล์");
            } else {
              var reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onloadend = function() {
                var base64data = reader.result;
                setPDF(base64data);
              };
            }
          },
          error => {
            console.log(error);
          }
        );

      setFullScreen(true);
    }
  };

  const setFullScreenButton = evt => {
    setFullScreen(false);
  };

  useEffect(() => {
    axios("/api/v1/download/signature/" + 28 + "/" + customData, {
      method: "POST",
      responseType: "blob",
      validateStatus: acceptDownloadResponse
    })
      .then(response => ((response.status >= 200 && response.status < 300) ? response.data : false))
      //.then(response => response.blob())
      .then(
        blob => {
          if (!blob) {
            console.log("ไม่พบไฟล์");
          } else {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function() {
              var base64data = reader.result;
              setImageURL(base64data);
            };
          }
        },
        error => {
          console.log(error);
        }
      );

    axios("/api/v1/download/signature/" + 30 + "/" + customData, {
      method: "POST",
      responseType: "blob",
      validateStatus: acceptDownloadResponse
    })
      .then(response => ((response.status >= 200 && response.status < 300) ? response.data : false))
      //.then(response => response.blob())
      .then(
        blob => {
          if (!blob) {
            console.log("ไม่พบไฟล์");
          } else {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function() {
              var base64data = reader.result;
              setImageURL2(base64data);
            };
          }
        },
        error => {
          console.log(error);
        }
      );
  });

  return (
    <div>
      <Grid>
        <Col xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>
                คำรับรองการปฏิบัติราชการ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้
                จังหวัดตรัง
              </h4>
              <p className={classes.cardCategoryWhite}>
                {" "}
                ประจำปีงบประมาณ พ.ศ. ๒๕๖๘{" "}
              </p>
            </CardHeader>

            <CardBody>
              <Grid>
                <Col xs={12} sm={12} md={12}>
                  <div style={{ textAlign: "center" }}>
                    <img
                      style={{ width: "13%", paddingBottom: "20px" }}
                      src={garuda}
                      alt="..."
                    />
                  </div>
                </Col>
              </Grid>
              <Grid>
                <Col xs={12} sm={12} md={12}>
                  <div style={{ textAlign: "center" }}>
                    <label
                      style={{
                        fontWeight: "bold",
                        paddingTop: "5px",
                        fontSize: "18px"
                      }}
                    >
                      คำรับรองการปฏิบัติราชการ
                    </label>
                    <br />
                    <label
                      style={{
                        fontWeight: "bold",
                        paddingTop: "5px",
                        fontSize: "18px"
                      }}
                    >
                      โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
                    </label>
                    <br />
                    <label
                      style={{
                        fontWeight: "bold",
                        paddingTop: "5px",
                        fontSize: "18px"
                      }}
                    >
                      ประจำปีงบประมาณ พ.ศ. ๒๕๖๘
                    </label>
                  </div>
                </Col>
              </Grid>
              <Grid>
                <Col xs={1} sm={1} md={1}>
                  <label
                    style={{
                      paddingTop: "20px",
                      fontSize: "16px"
                    }}
                  >
                    ๑.
                  </label>
                </Col>
                <Col xs={11} sm={11} md={11}>
                  <label
                    style={{
                      paddingTop: "20px",
                      fontSize: "16px"
                    }}
                  >
                    คำรับรองระหว่าง
                  </label>
                </Col>
              </Grid>
              <Grid style={{ paddingTop: "20px" }}>
                <Col xs={1} sm={1} md={1}>
                  <label
                    style={{
                      paddingTop: "20px",
                      fontSize: "16px"
                    }}
                  ></label>
                </Col>
                <Col xs={4} sm={4} md={3}>
                  {isMobile ? (
                    <span style={{ paddingLeft: "10%" }}></span>
                  ) : (
                    <span style={{ paddingLeft: "20%" }}></span>
                  )}
                  <label style={{ fontSize: "16px", lineHeight: "2em" }}>
                    นายวรพล  เวชชาภินันท์
                  </label>
                </Col>
                <Col xs={5} sm={5} md={5}>
                  <label
                    style={{
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    รองผู้อำนวยการด้านการพัฒนาระบบสุขภาพ
                  </label>
                </Col>
                <Col xs={2} sm={2} md={3}>
                  <label
                    style={{
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    ผู้รับคำรับรอง <br />
                  </label>
                </Col>
              </Grid>
              <Grid style={{ paddingTop: "5px", textAlign: "center" }}>
                <Col xs={5} sm={5} md={4}></Col>
                <Col xs={5} sm={5} md={5}>
                  <label
                    style={{
                      fontSize: "16px"
                    }}
                  >
                    และ
                  </label>
                </Col>
                <Col xs={2} sm={2} md={3}></Col>
              </Grid>
              <Grid style={{ paddingTop: "5px" }}>
                <Col xs={1} sm={1} md={1}>
                  <label
                    style={{
                      paddingTop: "20px",
                      fontSize: "16px"
                    }}
                  ></label>
                </Col>
                <Col xs={4} sm={4} md={3}>
                  {isMobile ? (
                    <span style={{ paddingLeft: "10%" }}></span>
                  ) : (
                    <span style={{ paddingLeft: "20%" }}></span>
                  )}
                  <label style={{ fontSize: "16px", lineHeight: "2em" }}>
                    นายนิธิ ปานดำ
                  </label>
                </Col>
                <Col xs={5} sm={5} md={5}>
                  <label
                    style={{
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    หัวหน้ากลุ่มงานดิจิทัลการแพทย์
                  </label>
                </Col>
                <Col xs={2} sm={2} md={3}>
                  <label
                    style={{
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    ผู้ทำคำรับรอง <br />
                  </label>
                </Col>
              </Grid>
              <Grid>
                <Col xs={1} sm={1} md={1}>
                  <label
                    style={{
                      paddingTop: "20px",
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    ๒.
                  </label>
                </Col>
                <Col xs={11} sm={11} md={11}>
                  <label
                    style={{
                      paddingTop: "20px",
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    คำรับรองนี้เป็นคำรับรองฝ่ายเดียว มิใช่สัญญา
                    และใช้สำหรับระยะเวลา ๑ ปี เริ่มตั้งแต่วันที่ ๑ ตุลาคม ๒๕๖๗
                    ถึงวันที่ ๓๐ กันยายน ๒๕๖๘
                  </label>
                </Col>
              </Grid>
              <Grid>
                <Col xs={1} sm={1} md={1}>
                  <label
                    style={{
                      paddingTop: "20px",
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    ๓.
                  </label>
                </Col>
                <Col xs={11} sm={11} md={11}>
                  <label
                    style={{
                      paddingTop: "20px",
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    รายละเอียดของคำรับรอง ได้แก่ แผนปฏิบัติราชการประจำปี ๒๕๖๘
                    ของโรงพยาบาลโรคผิวหนังเขตร้อน ภาคใต้ จังหวัดตรัง
                    ตัวชี้วัดผลการปฏิบัติราชการ น้ำหนัก ข้อมูลพื้นฐาน
                    เป้าหมาย/เกณฑ์การให้คะแนน และ รายละเอียดอื่น ๆ
                    ตามที่ได้ประชุมตกลงกันในภารกิจ
                  </label>
                </Col>
              </Grid>
              <Grid>
                <Col xs={1} sm={1} md={1}>
                  <label
                    style={{
                      paddingTop: "20px",
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    ๔.
                  </label>
                </Col>
                <Col xs={11} sm={11} md={11}>
                  <label
                    style={{
                      paddingTop: "20px",
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    ข้าพเจ้า นายวรพล  เวชชาภินันท์ รองผู้อำนวยการด้านการพัฒนาระบบสุขภาพ
                    ในฐานะผู้บังคับบัญชาของ นายนิธิ 
                    ปานดำ หัวหน้ากลุ่มงานดิจิทัลการแพทย์ได้พิจารณาและเห็นชอบกับแผนปฏิบัติราชการ
                    ตัวชี้วัดผลการปฏิบัติราชการ น้ำหนัก ข้อมูลพื้นฐาน
                    เป้าหมาย/เกณฑ์การให้คะแนนและรายละเอียดอื่น ๆ
                    ตามที่กำหนดและข้าพเจ้ายินดีจะให้คำแนะนำ กำกับ
                    และตรวจสอบผลการปฏิบัติราชการของ นายนิธิ
                    ปานดำ หัวหน้ากลุ่มงานดิจิทัลการแพทย์ให้เป็นไปตามคำรับรองที่จัดทำขึ้นนี้
                  </label>
                </Col>
              </Grid>
              <Grid>
                <Col xs={1} sm={1} md={1}>
                  <label
                    style={{
                      paddingTop: "20px",
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    ๕.
                  </label>
                </Col>
                <Col xs={11} sm={11} md={11}>
                  <label
                    style={{
                      paddingTop: "20px",
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    ข้าพเจ้า นายนิธิ
                    ปานดำ หัวหน้ากลุ่มงานดิจิทัลการแพทย์ได้ทำความเข้าใจคำรับรองตาม
                    ข้อ ๓ แล้ว ขอให้คำรับรองกับ นายวรพล  เวชชาภินันท์ 
                    รองผู้อำนวยการด้านการพัฒนาระบบสุขภาพ
                    ว่าจะมุ่งมั่นปฏิบัติราชการให้เกิดผลงานที่ดีตามเป้าหมายของตัวชี้วัดแต่ละตัวในระดับสูงสุด
                    เพื่อให้เกิดประโยชน์สุขแก่ประชาชน ตามที่ให้คำรับรองไว้
                  </label>
                </Col>
              </Grid>
              <Grid>
                <Col xs={1} sm={1} md={1}>
                  <label
                    style={{
                      paddingTop: "20px",
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    ๖.
                  </label>
                </Col>
                <Col xs={11} sm={11} md={11}>
                  <label
                    style={{
                      paddingTop: "20px",
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    ผู้รับคำรับรองและผู้ทำคำรับรองได้เข้าใจคำรับรองการปฏิบัติราชการและเห็นพ้องกันแล้วจึงได้ลงลายมือชื่อ
                    ไว้เป็นสำคัญ
                  </label>
                </Col>
              </Grid>
              <Grid>
                <Col xs={6} sm={6} md={6} style={{ textAlign: "center" }}>
                  {imageURL2 ? (
                    <div
                      style={{
                        paddingTop: "9em"
                      }}
                    >
                      {imageURL ? (
                        <img
                          src={imageURL}
                          alt="my signature"
                          style={{
                            display: "block",
                            margin: "0 auto",
                            //width: "50%"
                            height: "150px"
                          }}
                        />
                      ) : (currentUser.userName == "madarakung" || currentUser.userName == "voraphol") && (
                        <Button color="primary" onClick={handleSubmit}>
                          <h6 style={{ fontSize: "16px" }}>ลงนาม</h6>
                        </Button>
                      )}
                    </div>
                  ) : (
                    <div></div>
                  )}
                </Col>
                <Col xs={6} sm={6} md={6} style={{ textAlign: "center" }}>
                  <div
                    style={{
                      paddingTop: "9em"
                    }}
                  >
                    {imageURL2 ? (
                      <img
                        src={imageURL2}
                        alt="my signature"
                        style={{
                          display: "block",
                          margin: "0 auto",
                          //width: "50%"
                          height: "150px"
                        }}
                      />
                    ) : (currentUser.userName == "madarakung" || currentUser.userName == "ton900") && (
                      <Button color="primary" onClick={handleSubmit2}>
                        <h6 style={{ fontSize: "16px" }}>ลงนาม</h6>
                      </Button>
                    )}
                  </div>
                </Col>
              </Grid>
              <Grid>
                <Col xs={6} sm={6} md={6} style={{ textAlign: "center" }}>
                  {" "}
                  <label
                    style={{
                      fontSize: "16px",
                      lineHeight: "2em",
                      paddingTop: "2em"
                    }}
                  >
                    (นายวรพล  เวชชาภินันท์)
                  </label>
                  <br />
                  <label
                    style={{
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    รองผู้อำนวยการด้านการพัฒนาระบบสุขภาพ
                  </label>
                  <br />
                  <label
                    style={{
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    วันที่ ๒๐ มกราคม ๒๕๖๘
                  </label>
                  <br />
                  <label
                    style={{
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    ผู้รับคำรับรอง
                  </label>
                  <br />
                  {imageURL && (currentUser.userName == "madarakung" || currentUser.userName == "voraphol") ? (
                    <Button color="primary" onClick={handleSubmit}>
                      <h6 style={{ fontSize: "16px" }}>แก้ไข</h6>
                    </Button>
                  ) : (
                    <label></label>
                  )}
                </Col>
                <Col xs={6} sm={6} md={6} style={{ textAlign: "center" }}>
                  {" "}
                  <label
                    style={{
                      fontSize: "16px",
                      lineHeight: "2em",
                      paddingTop: "2em"
                    }}
                  >
                    (นายนิธิ ปานดำ)
                  </label>
                  <br />
                  <label
                    style={{
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    หัวหน้ากลุ่มงานดิจิทัลการแพทย์
                  </label>
                  <br />
                  <label
                    style={{
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    วันที่ ๒๐ มกราคม ๒๕๖๘
                  </label>
                  <br />
                  <label
                    style={{
                      fontSize: "16px",
                      lineHeight: "2em"
                    }}
                  >
                    ผู้ทำคำรับรอง
                  </label>
                  <br />
                  {imageURL2 && (currentUser.userName == "madarakung" || currentUser.userName == "ton900") ? (
                    <Button color="primary" onClick={handleSubmit2}>
                      <h6 style={{ fontSize: "16px" }}>แก้ไข</h6>
                    </Button>
                  ) : (
                    <label></label>
                  )}
                </Col>
              </Grid>
            </CardBody>
            <CardFooter>
              <Collapse isOpen={isOpen}></Collapse>
              {/* Confirm */}
              <Modal toggle={() => setModal(false)} isOpen={modal}>
                <div className="modal-header justify-content-center">
                  <div>
                    <i
                      className={icon}
                      style={{ color: "blue", fontSize: "2em" }}
                    ></i>
                  </div>
                </div>
                <ModalBody>
                  <p
                    style={{
                      textAlign: "center"
                    }}
                  >
                    {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                      ? "ยืนยันการบันทึกข้อมูล"
                      : "กำลังตรวจสอบข้อมูล"}
                  </p>
                  <p> </p>
                </ModalBody>
                <div className="modal-footer">
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => setModal(false)}
                  >
                    <h4>ยกเลิก</h4>
                  </Button>

                  <Button
                    color="primary"
                    type="button"
                    disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                  >
                    <h4>ยืนยัน</h4>
                  </Button>
                </div>
              </Modal>

              {/* Error */}
              <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                <div className="modal-header justify-content-center">
                  <div>
                    <i
                      className="fa fa-times"
                      style={{ color: "red", fontSize: "2em" }}
                    ></i>
                  </div>
                </div>
                <ModalBody>
                  <p>ไม่สามารถบันทึกข้อมูลได้</p>
                  <div>{errMsg}</div>
                </ModalBody>
                <div className="modal-footer justify-content-center">
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => setModalError(false)}
                  >
                    <h4>ตกลง</h4>
                  </Button>
                </div>
              </Modal>

              <Modal toggle={() => setModalSig(false)} isOpen={modalSig}>
                <div className="modal-header justify-content-center">
                  <div>
                    <i
                      className={icon}
                      style={{ color: "blue", fontSize: "2em" }}
                    ></i>
                  </div>
                </div>
                <ModalBody>
                  <div
                    style={{
                      textAlign: "center"
                    }}
                  >
                    <SignaturePad
                      ref={sigCanvas}
                      canvasProps={{
                        className: classes2.signatureCanvas
                      }}
                      style={{
                        border: "1px solid black",
                        width: "100%",
                        minHeight: "300px"
                      }}
                    />
                  </div>
                </ModalBody>
                <div className="modal-footer">
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => setModalSig(false)}
                  >
                    <h4>ปิด</h4>
                  </Button>

                  <Button color="primary" type="button" onClick={clear}>
                    <h4>Clear</h4>
                  </Button>

                  <Button
                    color="primary"
                    type="button"
                    onClick={handleConfirm}
                    disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                  >
                    <h4>บันทึก</h4>
                  </Button>
                </div>
              </Modal>

              <Modal toggle={() => setModalSig2(false)} isOpen={modalSig2}>
                <div className="modal-header justify-content-center">
                  <div>
                    <i
                      className={icon}
                      style={{ color: "blue", fontSize: "2em" }}
                    ></i>
                  </div>
                </div>
                <ModalBody>
                  <div
                    style={{
                      textAlign: "center"
                    }}
                  >
                    <SignaturePad
                      ref={sigCanvas}
                      canvasProps={{
                        className: classes2.signatureCanvas
                      }}
                      style={{
                        border: "1px solid black",
                        width: "100%",
                        minHeight: "300px"
                      }}
                    />
                  </div>
                </ModalBody>
                <div className="modal-footer">
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => setModalSig2(false)}
                  >
                    <h4>ปิด</h4>
                  </Button>

                  <Button color="primary" type="button" onClick={clear}>
                    <h4>Clear</h4>
                  </Button>

                  <Button
                    color="primary"
                    type="button"
                    onClick={handleConfirm2}
                    disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                  >
                    <h4>บันทึก</h4>
                  </Button>
                </div>
              </Modal>

            { !configPolicy && imageURL === null && <Modal toggle={() => setModalPolicy(false)} isOpen={modalPolicy} size="lg">
                <div className="modal-header justify-content-center">
                  <div>
                    <i
                      className={icon}
                      style={{ color: "blue", fontSize: "2em" }}
                    ></i>
                  </div>
                </div>
                <ModalBody>
                  <p
                    style={{
                      textAlign: "center"
                    }}
                  >
                  </p>
                  
              <Grid>
                <Col xs={12} sm={12} md={12}>
                  <div style={{ textAlign: "center" }}>
                    <img
                      style={{ width: "13%", paddingBottom: "20px" }}
                      src={logo}
                      alt="..."
                    />
                  </div>
                </Col>
                <Col xs={12} sm={12} md={12} style={{ textAlign: "center" }}>
                  <label
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold"
                    }}
                  >
                    นโยบายการคุ้มครองข้อมูลส่วนบุคคล <br></br>
                    ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง พ.ศ. ๒๕๖๗ 
                  </label>
                </Col>
                <Col xs={12} sm={12} md={12} style={{ textAlign: "left" }}>
                  <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px"
                    }}
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง 
                    จัดทำนโยบายการคุ้มครองข้อมูลส่วนบุคคลของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรังเพื่อรักษาความปลอดภัยและป้องกันการนำข้อมูลส่วนบุคคลของผู้ใช้บริการเว็บไซต์ 
                    ภายใต้ Domain Name “https://e.trangskin.go.th/signature” ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้จังหวัดตรังไปใช้โดยมีเจตนาไม่สุจริต 
                    <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px"
                    }}
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    ๑. การเก็บรวบรวมข้อมูลส่วนบุคคลอย่างจำกัด โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
                    จะเก็บรวบรวมข้อมูลส่วนบุคคลของผู้ใช้บริการเว็บไซต์ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรังเท่าที่จำเป็น 
                    ได้แก่ ชื่อ นามสกุล เลขประจำตัวประชาชน อีเมล หมายเลขโทรศัพท์ ลายเซ็น เป็นต้น 
                    โดยขึ้นอยู่กับประเภทของบริการที่ท่านใช้ผ่านเว็บไซต์ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรังเช่น 
                    การลงนามคำรับรองอิเล็กทรอนิกส์ การลงทะเบียนกิจกรรมต่าง ๆ ที่ทำผ่านเว็บไซต์ ภายใต้ 
                    Domain Name “https://e.trangskin.go.th/signature” ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง 
                    </label>
                    <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px"
                    }}
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    ๒. การบันทึกข้อมูลผู้ใช้บริการ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง มีการเก็บบันทึกข้อมูลของผู้ใช้บริการเว็บไซต์ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง 
                    ได้แก่ หมายเลขไอพี (IP Address) วันที่ และเวลา เว็บไซต์ที่เข้าออกก่อนและหลัง ประเภทของโปรแกรมบราวเซอร์ (Browser) ชนิดของโปรแกรมค้นผ่าน (Browser Type) 
                    โดเมนเนม (Domain Name) บันทึกหน้าเว็บ (web page) เป็นต้น ทั้งนี้ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง จะนำข้อมูลที่ได้บันทึกหรือ เก็บรวบรวมไว้ 
                    ไปใช้ในการวิเคราะห์เชิงสถิติ หรือในการดำเนินการเพื่อปรับปรุงคุณภาพการให้บริการต่อไป โดยการบันทึกข้อมูลดังกล่าวเป็นไปตามมาตรา ๒๖ วรรคหนึ่งแห่งพระราชบัญญัติว่าด้วยการกระทำความผิดเกี่ยวกับคอมพิวเตอร์ พ.ศ. ๒๕๕๐ 
                    ซึ่งแก้ไขเพิ่มเติมโดยพระราชบัญญัติว่าด้วยการกระทำความผิดเกี่ยวกับคอมพิวเตอร์ (ฉบับที่ ๒) พ.ศ. ๒๕๖๐ ที่กำหนดให้ผู้ให้บริการต้องเก็บข้อมูลจราจรคอมพิวเตอร์ไว้ไม่น้อยกว่า ๙๐ วัน 
                    นับแต่วันที่ข้อมูลนั้นเข้าสู่ระบบคอมพิวเตอร์ แต่ในกรณีจำเป็น พนักงานเจ้าหน้าที่จะสั่งให้ผู้ให้บริการผู้ใดเก็บรักษาข้อมูลจราจรทางคอมพิวเตอร์ไว้เกิน ๙๐ วัน แต่ไม่เกิน ๒ ปี เป็นกรณีพิเศษเฉพาะรายและเฉพาะคราวก็ได้ 
                    </label>
                    <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px"
                    }}
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    ๓. การใช้ข้อมูลส่วนบุคคล โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง จะเก็บรวบรวม รักษา และใช้ข้อมูลส่วนบุคคลของท่านเพื่อประโยชน์ ในการให้บริการ 
                    และการดำเนินการตามวัตถุประสงค์และภารกิจของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ภายใต้ขอบเขตของกฎหมายที่เกี่ยวข้อง
                  </label>
                  <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px"
                    }}
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    ๔. ข้อจำกัดในการนำข้อมูลส่วนบุคคลไปใช้ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง จะมิให้มีการเปิดเผย หรือแสดง หรือทำให้ปรากฏในลักษณะอื่นใดซึ่งข้อมูลส่วนบุคคลที่ไม่สอดคล้องกับวัตถุประสงค์ของการรวบรวมและจัดเก็บข้อมูล 
                    เว้นแต่จะได้รับความยินยอมจากเจ้าของข้อมูล หรือเป็นกรณีที่มีกฎหมายกำหนดให้กระทำได้ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง จะมิให้มีการเปิดเผยข้อมูลส่วนบุคคลของท่านแก่บุคคลที่สามเพื่อนำไปใช้ในการดำเนินกิจกรรมที่ไม่เกี่ยวข้อง เช่น การเสนอขายสินค้าทางโทรศัพท์ เป็นต้น
                  </label>
                  <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px"
                    }}
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    ๕. การรักษาความมั่นคงปลอดภัยสำหรับข้อมูลส่วนบุคคล โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง มีการใช้มาตรการด้านความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลอย่างเหมาะสมเพื่อป้องกันการสูญหาย การเข้าถึง ทำลาย ใช้ แปลง แก้ไข 
                    หรือเปิดเผยข้อมูลโดยมิชอบ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ได้จำกัดการเข้าใช้งานข้อมูลส่วนบุคคลไว้เพียงเจ้าหน้าที่โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ที่เกี่ยวข้อง โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง 
                    กำหนดให้ผู้รับจ้าง (Outsource) จำเป็นต้องเก็บรักษาความลับและความปลอดภัยของข้อมูลของผู้ใช้บริการ โดยห้ามนำข้อมูลไปใช้นอกเหนือจากที่กำหนดให้ดำเนินการ  
                  </label>
                  <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px"
                    }}
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    ๖. ข้อแนะนำในการการรักษาความปลอดภัยข้อมูลส่วนบุคคล การใช้บริการทางอิเล็กทรอนิกส์ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ท่านจะได้รับชื่อผู้ใช้งาน 
                    (User) และรหัสผ่าน (Password) สำหรับเข้าสู่ระบบ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง จะเป็นผู้กำหนดชื่อผู้ใช้งาน (User) และรหัสผ่าน (Password) 
                    ให้ท่าน โดยท่านมีหน้าที่รักษาชื่อผู้ใช้งาน (User) และรหัสผ่าน (Password) ของท่านอย่างเคร่งครัด ไม่เปิดเผยข้อมูลดังกล่าวแก่บุคคลอื่น ทั้งนี้ เมื่อระบบได้รับการพัฒนาโดยสมบูรณ์แล้ว 
                    ท่านสามารถเปลี่ยนรหัสผ่าน (Password) ได้ด้วยตัวของท่านเอง และข้อควรปฏิบัติคือ ทุกครั้งที่ท่านใช้บริการเสร็จแล้ว ควรคลิก “ออกจากระบบ” เพื่อป้องกันมิให้ผู้อื่นสามารถทำรายการจากบัญชีผู้ใช้งานของท่านได้ 
                  </label>
                  <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px"
                    }}
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    ๗. การใช้คุกกี้ (Cookies) คุกกี้ (Cookies) เป็นกระบวนการเพื่อทำให้ผู้ใช้บริการสามารถใช้งานเว็บไซต์ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ได้สะดวกขึ้น 
                    คุกกี้มีประโยชน์สำหรับให้เว็บเซิร์ฟเวอร์สามารถเรียกใช้ข้อมูลเหล่านั้นได้ในภายหลัง คุกกี้จะถูกติดตั้งในขณะที่ท่านเรียกดูเว็บไซต์ หลังจากที่ท่านเลิกใช้งานโปรแกรมบราวเซอร์ (Browser) 
                    แล้วคุกกี้บางตัวจะถูกจัดเก็บไว้ที่เครื่องคอมพิวเตอร์ของท่านในรูปแบบไฟล์ หรืออาจจะหมดอายุ หรือไม่มีการเก็บ ท่านสามารถปรับโปรแกรมบราวเซอร์ (Browser) ของท่านให้รองรับการทำงานของคุกกี้หรือไม่ก็ได้ 
                  </label>
                  <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px"
                    }}
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    ๘. การปรับปรุงนโยบายการคุ้มครองข้อมูลส่วนบุคคล โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง อาจทำการปรับปรุงหรือแก้ไขนโยบายการคุ้มครองข้อมูลส่วนบุคคลโดยไม่ได้แจ้งให้ท่านทราบล่วงหน้า ทั้งนี้ 
                    เพื่อความเหมาะสมและประสิทธิภาพในการให้บริการ ดังนั้น โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ขอแนะนำให้ท่านอ่านนโยบายคุ้มครองข้อมูลส่วนบุคคลทุกครั้งที่ใช้บริการเว็บไซต์ Domain Name 
                    “https://e.trangskin.go.th/signature” ของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
                  </label>
                  <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px"
                    }}
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    ๙. การปฏิบัติตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลและการติดต่อกับโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง กำหนดให้เจ้าหน้าที่โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง 
                    ที่เกี่ยวข้องต้องให้ความสำคัญและรับผิดชอบในการคุ้มครองข้อมูลส่วนบุคคล เพื่อให้เป็นไปตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง
                  </label>
                  <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px"
                    }}
                  >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  ในกรณีที่ท่านมีข้อสงสัย ข้อเสนอแนะ หรือข้อติชมใดๆ เกี่ยวกับนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ยินดีที่จะตอบข้อสงสัย รับฟังข้อเสนอแนะ และคำติชมทั้งหลาย 
                  อันจะเป็นประโยชน์ต่อการปรับปรุงการให้บริการของโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ต่อไป โดยท่านสามารถติดต่อกับโรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง ได้ตามช่องทางดังต่อไปนี้
                  </label>
                  </label>
                </Col>
              </Grid>

                </ModalBody>
                <div className="modal-footer"  style={{
                        justifyContent: "center"
                      }}>
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => setModalPolicy()}
                  >
                    <h4>ยืนยัน</h4>
                  </Button>
                </div>
              </Modal>
            }
            
            { configPolicy && imageURL === null && <Modal toggle={() => setModalPolicy2(false)} isOpen={modalPolicy2} size="lg">
                <div className="modal-header justify-content-center">
                  <div>
                    <i
                      className={icon}
                      style={{ color: "blue", fontSize: "2em" }}
                    ></i>
                  </div>
                </div>
                <ModalBody>
                  <p
                    style={{
                      textAlign: "center"
                    }}
                  >
                  </p>
                  
              <Grid>
              <Col xs={12} sm={12} md={12}>
                  <div style={{ textAlign: "center" }}>
                    <img
                      style={{ width: "13%", paddingBottom: "20px" }}
                      src={logoDMS}
                      alt="..."
                    />
                  </div>
                </Col>
                <Col xs={12} sm={12} md={12} style={{ textAlign: "center" }}>
                  <label
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold"
                    }}
                  >
                    ประกาศกรมการแพทย์ <br></br>
                    เรื่อง แนวปฏิบัติการคุ้มครองข้อมูลส่วนบุคคล
                    <br></br>
                    ________________________ <br></br>
                  </label>
                </Col>
                <Col xs={12} sm={12} md={12} style={{ textAlign: "left" }}>
                    <label
                      style={{
                      fontSize: "16px",
                      paddingTop: "10px"
                    }}
                    >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    เพื่อให้เป็นไปตามพระราชบัญญัติการคุ้มครองข้อมูลส่วนบุคคล พ.ศ. ๒๕๖๒ และให้
                    สอดคล้องตามนโยบายการคุ้มครองข้อมูลส่วนบุคคล กรมการแพทย์ กระทรวงสาธารณสุข จึงได้กำหนด
                    แนวทางปฏิบัติการคุ้มครองข้อมูลส่วนบุคคลไว้ ดังต่อไปนี้ 
                    </label>
                    <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px",
                      marginBottom: "0px"
                    }}
                    >
                    ส่วนที่ ๑ : ผู้มีหน้าที่เกี่ยวข้องกับการคุ้มครองข้อมูลส่วนบุคคล<br></br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    หน่วยงานของกรมการแพทย์ หมายถึง หน่วยงานในสังกัดกรมการแพทย์ทุกหน่วยงาน มีผลบังคับใช้
                    กับข้าราชการ พนักงาน ผู้ปฏิบัติงาน รวมถึงบุคคลภายนอกผู้ซึ่งปฏิบัติงานให้หน่วยงานของกรมการแพทย์ ได้แก่
                    </label>
                    <label
                    style={{
                      fontSize: "16px",
                      paddingLeft: "55px"
                    }}
                  >
                    (๑) สำนักงานเลขานุการกรม <br></br>
                    (๒) กองบริหารการคลัง<br></br>
                    (๓) สถาบันวิจัยและประเมินเทคโนโลยีทางการแพทย์<br></br>
                    (๔) กองบริหารทรัพยากรบุคคล<br></br>
                    (๕) กองยุทธศาสตร์และแผนงาน<br></br>
                    (๖) กองวิชาการแพทย์<br></br>
                    (๗) สำนักนิเทศระบบการแพทย์<br></br>
                    (๘) กลุ่มตรวจสอบภายใน<br></br>
                    (๙) กลุ่มพัฒนาระบบบริหาร<br></br>
                    (๑๐) สำนักดิจิทัลการแพทย์<br></br>
                    (๑๑) กองกฎหมายและคุ้มครองจริยธรรม<br></br>
                    (๑๒)โรงพยาบาลนพรัตนราชธานี<br></br>
                    (๑๓) สถาบันอาชีวเวชศาสตร์และเวชศาสตร์สิ่งแวดล้อม<br></br>
                    (๑๔) โรงพยาบาลเมตตาประชารักษ์ (วัดไร่ขิง)<br></br>
                    (๑๕) โรงพยาบาลราชวิถี<br></br>
                    (๑๖) โรงพยาบาลเลิดสิน<br></br>
                    (๑๗) โรงพยาบาลสงฆ์<br></br>
                    (๑๘) สถาบันสิรินธรเพื่อการฟื้นฟูสมรรถภาพทางการแพทย์แห่งชาติ<br></br>
                    (๑๙) สถาบันทันตกรรม<br></br>
                    (๒๐) สถาบันประสาทวิทยา<br></br>
                    (๒๑) สถาบันพยาธิวิทยา<br></br>
                    (๒๒) สถาบันมะเร็งแห่งชาติ<br></br>
                    (๒๓) สถาบันบำบัดรักษาและฟื้นฟูผู้ติดยาเสพติดแห่งชาติบรมราชชนนี<br></br>
                    (๒๔) สถาบันโรคทรวงอก<br></br>
                    (๒๕) สถาบันโรคผิวหนัง<br></br>
                    (๒๖) สถาบันเวชศาสตร์สมเด็จพระสังฆราชญาณสังวรเพื่อผู้สูงอายุ/ศูนยันวัตกรรมสุขภาพผู้สูงอายุ<br></br>
                    (๒๗) สถาบันสุขภาพเด็กแห่งชาติมหาราชินี<br></br>
                    (๒๘) สถานพยาบาลกระทรวงสาธารณสุข<br></br>
                    (๒๙) สถาบันร่วมผลิตแพทย์ กรมการแพทย์ (มหาวิทยาลัยรังสิต)<br></br>
                    (๓๐) สถาบันเวชศาสตร์การออกกำลังกายและการกีฬา<br></br>
                    (๓๑) โรงพยาบาลประสาทเชียงใหม่<br></br>
                    (๓๒) โรงพยาบาลมะเร็งชลบุรี<br></br>
                    (๓๓) โรงพยาบาลมะเร็งลพบุรี<br></br>
                    (๓๔) โรงพยาบาลมะเร็งลำปาง<br></br>
                    (๓๕) โรงพยาบาลมะเร็งอุบลราชธานี<br></br>
                    (๓๖) โรงพยาบาลมะเร็งอุดรธานี<br></br>
                    (๓๗) โรงพยาบาลมะเร็งสุราษฎร์ธานี<br></br>
                    (๓๘) โรงพยาบาลมหาวชิราลงกรณธัญบุรี<br></br>
                    (๓๘) โรงพยาบาลธัญญารักษ์เชียงใหม่<br></br>
                    (๔๐) โรงพยาบาลธัญญารักษ์สงขลา<br></br>
                    (๔๑) โรงพยาบาลธัญญารักษ์ขอนแก่น<br></br>
                    (๔๒) โรงพยาบาลธัญญารักษ์ปัตตานี<br></br>
                    (๔๓) โรงพยาบาลธัญญารักษ์แม่ฮ่องสอน<br></br>
                    (๔๔) โรงพยาบาลธัญญารักษ์อุดรธานี<br></br>
                    (๔๕) โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง<br></br>
                    (๔๖) โรงพยาบาลสมเด็จพระสังฆราชญาณสังวรเพื่อผู้สูงอายุ จังหวัดชลบุรี<br></br>
                    (๔๗) โรงพยาบาลเวชชารักษ์ลำปาง
                    </label>
                    <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px",
                    }}
                    >
                      ส่วนที่ ๒ : ข้อมูลส่วนบุคคลที่ได้รับการคุ้มครอง <br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      ๒.๑ ข้อมูลส่วนบุคคลของบุคลากรหน่วยงานของกรมการแพทย์ เป็นข้อมูลส่วนบุคคล ของข้าราชการ
                      พนักงานราชการ หนักงานกระทรวงสาธารณสุข ลูกจ้างประจำ ลูกจ้างชั่วคราวของหน่วยงานของกรมการแพทย์<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      ๒.๒ ข้อมูลส่วนบุคคลของผู้มาติดต่องาน เป็นข้อมูลส่วนบุคลคลของผู้มาติดต่องาน สมัครงาน
                      การทำธุรกรรม เช่น การขอใบอนุญาตต่างๆ การส่งตรวจสิ่งส่งตรวจทางห้องปฏิบัติการ เป็นต้น การทำนิติกรรม
                      เช่น การทำสัญญาว่าจ้างสัญญาซื้อขาย รวมถึงข้อมูลส่วนบุคคลของพนักงาน หรือลูกจ้างของหน่วยงาน
                      ที่ทำสัญญา หรือทำงานให้กับหน่วยงานของกรมการแพทย์<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      ๒.๓ ข้อมูลส่วนบุคคลของผู้รับบริการเป็นข้อมูลส่วนบุคคลของผู้มาติดต่อเพื่อรับบริการ
                      ทางการแพทย์และสาธารณสุขของหน่วยบริการสุขภาพ รวมถึงข้อมูลส่วนบุคคลของผู้รับบริการกรณีที่บุคลากร
                      ของหน่วยบริการสุขภาพของหน่วยงานออกไปให้บริการนอกหน่วยบริการในพื้นที่ที่รับผิดชอบ
                    </label>
                    <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px",
                    }}
                    >
                      ส่วนที่ ๓ : การเก็บรวบรวมข้อมูลส่วนบุคคลอย่างจำกัด<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      หน่วยงานของกรมการแพทย์จะเก็บรวบรวมข้อมูลส่วนบุคคล "เท่าที่จำเป็น" สำหรับการให้บริการ
                      ตามวัตถุประสงค์ในการดำเนินงานของกรมการแพทย์อย่างเคร่งครัดและจะขอความยินยอมจากเจ้าของข้อมูล
                      ส่วนบุคคลก่อนหรือขณะที่เก็บรวบรวมข้อมูลส่วนบุคคล เว้นแต่การเก็บรวบรวมข้อมูลส่วนบุคคลที่ได้รับยกเว้น
                      ไม่ต้องขอความยินยอมตามที่กฎหมายกำหนดและจะรักษาข้อมูลเหล่านั้นไว้เป็นความลับตามเกณฑ์มาตรฐาน
                      การกำหนดชั้นความลับของข้อมูลของกรมการแพทย์
                    </label>
                    <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px",
                    }}
                    >
                      ส่วนที่ ๔ : วัตถุประสงค์ในการเก็บรวบรวม ใช้ เปิดเผยข้อมูลส่วนบุคคล<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      ๔.๑ หน่วยงานของกรมการแพทย์จะเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของเจ้าของ
                      ข้อมูลส่วนบุคคลเพื่อการดำเนินงานในพันธกิจต่าง ๆ ของกรมการแพทย์ รวมทั้งเพื่อการศึกษาวิจัยหรือ
                      การจัดทำสถิติที่เป็นไปตามวัตถุประสงค์การดำเนินงานของกรมการแพทย์ หรือตามที่กฎหมายกำหนด<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      ๔.๒ หน่วยงานกรมการแพทย์จะบันทึกวัตถุประสงค์ของการเก็บรวบรวมข้อมูลส่วนบุคคลในขณะ
                      ที่มีการรวบรวมและจัดเก็บ รวมถึงการนำข้อมูลนั้นไปใช้ในภายหลังและแจ้งให้เจ้าของข้อมูลทราบหากมี
                      การเปลี่ยนแปลงวัตถุประสงค์ของการเก็บรวบรวมข้อมูล
                    </label>
                    <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px",
                    }}
                    >
                      ส่วนที่ ๕ : การกำกับดูแลการเก็บรวบรวม ใช้ และการเปิดเผยข้อมูลส่วนบุคคล<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      ๕.๑ หน่วยงานของกรมการแพทย์จะกำกับดูแลมิให้ผู้ที่ไม่มีหน้าที่ หรือไม่ได้รับมอบหมาย
                      เก็บรวบรวมข้อมูลส่วนบุคคลนำไปใช้ประโยชน์ เปิดเผย แสดง หรือทำให้ปรากฎในลักษณะอื่นใดแก่บุคคลอื่น
                      นอกเหนือจากวัตถุประสงค์ที่ได้ขอความยินยอมจากเจ้าของข้อมูลส่วนบุคคล เว้นแต่การใช้ข้อมูลส่วนบุคคล
                      ที่ได้รับการยกเว้นไม่ต้องขอความยินยอมตามที่กฎหมายกำหนด<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      ๕.๒ หน่วยงานของกรมการแพทย์จะไม่เปิดเผยข้อมูลส่วนบุคคลของเจ้าของโดยไม่มีฐาน
                      การประมวลผลข้อมูลโดยชอบด้วยกฎหมายแต่อาจเปิดเผยข้อมูลส่วนบุคคลของเจ้าของข้อมูล
                      ภายใต้หลักเกณฑ์ที่กฎหมายกำหนด เช่น การเปิดเผยต่อหน่วยงานราชการ หน่วยงานภาครัฐ หน่วยงานที่กำกับ
                      ดูแล รวมถึงในกรณีที่มีการร้องขอ ให้เปิดเผยข้อมูลโดยอาศัยอำนาจตามกฎหมาย
                    </label>
                    <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px",
                    }}
                    >
                      ส่วนที่ ๖ : การโอนข้อมูลไปต่างประเทศ<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      หน่วยงานของกรมการแพทย์จะทำการเปิดเผยข้อมูลส่วนบุคคลต่อผู้รับข้อมูลในต่างประเทศเฉพาะ
                      กรณีที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนดให้ทำได้เท่านั้น ทั้งนี้หน่วยงานของกรมการแพทย์อาจปฏิบัติ
                      ตามหลักเกณฑ์การโอนข้อมูลระหว่างประเทศ โดยเข้าทำข้อสัญญามาตรฐาน หรือใช้กลไกอื่นที่พึงมีตามกฎหมาย
                      ว่าด้วยการคุ้มครองข้อมูลที่ใช้บังคับ และหน่วยงานของกรมการแพทย์อาจอาศัยสัญญาการโอน ข้อมูล หรือกลไกอื่น
                      ที่ได้รับการอนุมัติเพื่อการโอนข้อมูลส่วนบุคคลไปยังต่างประเทศ
                    </label>
                    <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px",
                    }}
                    >
                      ส่วนที่ ๗ : การรักษาความมั่นคงปลอดภัย<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      ๗.๑ หน่วยงานกรมการแพทย์จะกำหนดมาตรการในการรักษาความมั่นคงปลอดภัยของข้อมูล
                      ส่วนบุคคลอย่างเหมาะสมเป็นไปตามมาตรฐานและข้อกำหนดที่เกี่ยวข้องเพื่อป้องกันการสูญหาย การเข้าถึง
                      ใช้ เปลี่ยนแปลง หรือเปิดเผยข้อมูลส่วนบุคคลโดยผู้ที่ไม่มีสิทธิ หรือโดยไม่ชอบด้วยกฎหมาย<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      ๗.๒ หน่วยงานของกรมการแพทย์จะดำเนินการลบ หรือทำลายข้อมูลส่วนบุคคลเมื่อพันกำหนด
                      ระยะเวลาการเก็บ หรือหมดความจำเป็นตามวัตถุประสงค์ในการเก็บรวบรวมข้อมูลส่วนบุคคล
                      หรือเมื่อเจ้าของข้อมูลส่วนบุคคลร้องขอ หรือเจ้าของข้อมูลส่วนบุคคลได้เพิกถอนความยินยอม เว้นแต่
                      การเก็บรักษาข้อมูลส่วนบุคคลที่ได้รับการยกเว้นไม่ต้องขอความยินยอมตามที่กฎหมายกำหนด
                    </label>
                    <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px",
                    }}
                    >
                      ส่วนที่ ๘ : การมีส่วนร่วมของเจ้าของข้อมูล<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      หน่วยงานของกรมการแพทย์ จะเก็บรวบรวมข้อมูลส่วนบุคคลจากเจ้าของข้อมูลส่วนบุคคล
                      โดยตรงเท่านั้นและต้อง "ขอความยินยอมจากเจ้าของข้อมูลส่วนบุคคลก่อน หรือระหว่างการเก็บรวบรวมข้อมูล
                      ส่วนบุคคล" เว้นแต่การเก็บรวบรวมข้อมูลส่วนบุคคลที่ได้รับการยกเว้นไม่ต้องขอความยินยอม
                      ตามที่กฎหมายกำหนด และหากหน่วยงานของกรมการแพทย์จำเป็นต้อง "เก็บรวบรวมข้อมูลส่วนบุคคล
                      จากแหล่งอื่น"ที่ไม่ใช่การเก็บข้อมูล จากเจ้าของข้อมูลส่วนบุคคลโดยตรง หน่วยงานกรมการแพทย์
                      จะแจ้งเหตุผลความจำเป็นนั้น ให้เจ้าของข้อมูลส่วนบุคคลทราบ เว้นแต่การเก็บรวบรวมข้อมูลส่วนบุคคล
                      ที่ได้รับยกเว้นไม่ต้องขอความยินยอมตามที่กฎหมายกำหนด
                    </label>
                    <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px",
                    }}
                    >
                      ส่วนที่ ๙ : สิทธิของเจ้าของข้อมูลส่วนบุคคล<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      เจ้าของข้อมูลส่วนบุคคลมีสิทธิในการดำเนินการ ดังต่อไปนี้<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      ๙.๑ สิทธิในการขอรับข้อมูลส่วนบุคคลของตนเอง โดยอาจขอให้หน่วยงานของกรมการแพทย์
                      ทำสำเนาข้อมูลส่วนบุคคลดังกล่าวให้แก่ตนเอง รวมถึงการขอให้เปิดเผยการได้มาซึ่งข้อมูลส่วนบุคคล
                      ที่เจ้าของข้อมูลส่วนบุคคลไม่ได้ให้ความยินยอมได้<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      ๙.๒ สิทธิคัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของตนเองด้วยเหตุบางประการตามที่กฎหมายกำหนด<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      ๙.๓ สิทธิขอให้ลบหรือทำลายข้อมูล โดยขอให้หน่วยงานของกรมการแพทย์ดำเนินการลบ หรือทำลาย
                      หรือที่ให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลส่วนบุคคลได้ด้วยเหตุ
                      บางประการได้ตามที่กฎหมายกำหนด<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      ๙.๔ สิทธิขอให้ระงับการใช้โดยขอให้หน่วยงานของกรมการแพทย์ระงับการใช้ข้อมูลส่วนบุคคล
                      ของตนเองด้วยเหตุบางประการได้ตามที่กฎหมายกำหนด<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      ๙.๕ สิทธิขอให้แก้ไข เปลี่ยนแปลง โดยขอให้หน่วยงานของกรมการแพทย์ดำเนินการให้ข้อมูล
                      ส่วนบุคคลนั้น มีความถูกต้องเป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด<br></br>
                    </label>
                    <label
                    style={{
                      fontSize: "16px",
                      paddingTop: "10px",
                    }}
                    >
                      ส่วนที่ ๑๐ : การเปิดเผยเกี่ยวกับการดำเนินการ นโยบาย และแนวปฏิบัติที่เกี่ยวกับข้อมูลส่วนบุคคล<br></br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      กรมการแพทย์มีการดำเนินการตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลของกรมการแพทย์
                      โดยจะเผยแพร่ผ่านทางเว็บไซต์ https://dms.go.th และเว็บไซต์ของหน่วยงาน รวมทั้งหากมีการปรับปรุง
                      แก้ไขนโยบายการคุ้มครองข้อมูลส่วนบุคคล ก็จะดำเนินการเผยแพร่ผ่านช่องทางดังกล่าว รวมทั้งผ่าน
                      การสื่อสารตามช่องทางที่กรมการแพทย์ใช้เพื่อการประชาสัมพันธ์ตามความเหมาะสมด้วย
                    </label>
                </Col>
              </Grid>

                </ModalBody>
                <div className="modal-footer"  style={{
                        justifyContent: "center"
                      }}>
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => handleSubmitPolicy(false)}
                  >
                    <h4>ยืนยัน</h4>
                  </Button>
                </div>
              </Modal>
            }
            </CardFooter>
          </Card>
        </Col>

        {fullScreen && <ReactFullScreenElement
              fullScreen={fullScreen}
              allowScrollbar={true}
            >
               <KeyboardEventHandler
                  handleKeys={["esc"]}
                  onKeyEvent={(key, e) => setFullScreenKey(key)}></KeyboardEventHandler>
              <Card>
                <CardHeader>
                  <Card>
                  </Card>
                </CardHeader>
                <CardBody>
                <img
                  src={PDF}
                  alt="my signature"
                  style={{
                  display: "block",
                  margin: "0 auto",
                  width: "100%"
                  }}
                  />

                </CardBody>
                <CardFooter style={{
                        justifyContent: "center"
                      }}>
                <Button color="primary" onClick={setFullScreenButton} >
                    <h6 style={{ fontSize: "16px" }}>ตกลง</h6>
                </Button>
                </CardFooter>
              </Card>
            </ReactFullScreenElement>}

      </Grid>
    </div>
  );
};
export default Digital2568;
